import { AbstractFeatureChildQueryEntity } from '@y42/feature';
import { DataTestableState, DataTestableUIModel } from './data-testable.model';

export abstract class DataTestableQuery<
  State extends DataTestableState = DataTestableState,
  UIModel extends DataTestableUIModel = DataTestableUIModel,
> extends AbstractFeatureChildQueryEntity<State, UIModel> {}
